export class UrlConstant {
	public static homePage: string = "/";
	public static loginPage: string = "/login";
	
	public static apiHome: string = "/";
	public static apiLogin: string = "/api/login-system-ws/ws/admin/login";
	public static apiValidateLogin: string = "/api/login-system-ws/ws/admin/login/validate";
	public static apiLogout: string = "/api/login-system-ws/ws/admin/logout";

	//public static apiChangePassword: string = "/api/ws/user/changePass";
	public static apiChangePassword: string = "/api/ols-ws/ws/user/changePass";
	
	public static apiGetAllCompanyTypes: string = "/api/ols-ws/ws/getAllCompanyTypes";
	public static apiGetAllIndividualTypes: string = "/api/ols-ws/ws/getAllIndividualTypes";
	public static apiGetAllAddressTypes: string = "/api/ols-ws/ws/getAllAddressTypes";
	public static apiGetAllContactTypes: string = "/api/ols-ws/ws/getAllContactTypes";
	
	public static apiGetAffiliatorSuggesition: string = "/api/ols-ws/ws/getAffiliatorSuggesition";
	
	public static apiGetActiveUserSession: string = "/api/ols-ws/ws/getActiveUserSession";
	
	//Below URL must be called after login success of the user.
	public static apiGetLoggedInUserData: string = "/api/ols-ws/ws/getLoggedInUserData";
	public static apiGetLoggedInUserAllPrivileges: string = "/api/ols-ws/ws/getAllPrivilegesByUserId";
	public static apiGetLoggedInUserAllRoleMappedPrivAndPrivilegesByUserId: string = "/api/ols-ws/ws/getAllRoleMappedPrivAndPrivilegesByUserId";
	public static apiGetLoggedInUserAllRoles: string = "/api/ols-ws/ws/getAllRolesByUserId";

	public static apiGetLoggedInUserDataWithAllPrivileges: string = "/api/ols-ws/ws/getLoggedInUserDataWithAllPrivileges";

	public static apiGetEducationalSystemCount: string = "/api/ols-ws/ws/getEduSysCount";
	public static apiGetEducationalSystem: string = "/api/ols-ws/ws/getEduSys";
	public static apiCreateEducationalSystem: string = "/api/ols-ws/ws/createEduSys";
	public static apiUpdateEducationalSystem: string = "/api/ols-ws/ws/updateEduSys";
	//public static apiDeleteEducationalSystem: string = "/api/ws/deleteEduSys";
	public static apiDeleteEducationalSystem: string = "/api/ols-ws/ws/deleteEduSys";
	
	
	public static apiGetIndividualCount: string = "/api/ols-ws/ws/getIndividualCount";
	public static apiGetIndividual: string = "/api/ols-ws/ws/getIndividual";
	public static apiCreateIndividual: string = "/api/ols-ws/ws/createIndividual";
	public static apiCreateIndividualWithEvalLinkGeneration: string = "/api/ols-ws/ws/createIndividualWithEvalLinkGeneration";
	public static apiUpdateIndividual: string = "/api/ols-ws/ws/updateIndividual";
	public static apiUpdateIndividualStatus: string = "/api/ols-ws/ws/updateIndividualStatus";
	
	//public static apiDeleteIndividual: string = "/api/ols-ws/ols-ws/ws/deleteIndividual";
	public static apiDeleteIndividual: string = "/api/ols-ws/ws/deleteIndividual";
	public static apiHardDeleteIndividual: string = "/api/ols-ws/ws/hardDeleteIndividual";
	
	public static apiGetVideoConfig: string = "/api/ols-ws/ws/getVideoConfig";
	public static apiCreateVideoConfig: string = "/api/ols-ws/ws/createVideoConfig";
	public static apiUpdateVideoConfig: string = "/api/ols-ws/ws/updateVideoConfig";
	//public static apiDeleteVideoConfig: string = "/api/ols-ws/ols-ws/ws/deleteVideoConfig";
	public static apiDeleteVideoConfig: string = "/api/ols-ws/ws/deleteVideoConfig";
	
	public static apiSignup: string = "/api/ols-ws/ws/signup";
	public static apiSignupZed: string = "/api/ols-ws/ws/signupZed";
	
	//public static apiWsActive: string = "/api/ws/";
	public static apiWsActive: string = "/api/ols-ws/ws/";
	public static apiGetStaticData: string = "/api/ols-ws/ws/getStaticData";
	
	public static apiWriteToUs: string = "/api/ols-ws/ws/writeToUs";
	
	
	public static htmlTestSeriesInitPage: string = "/html/test-series/init.test";
	public static htmlTestSeriesQuestionInitPage: string = "/html/test-series/createQuestionInitPage.test";
	//public static apiDeleteEducationalSystem: string = "/test-series/createQuestionInitPage.test";
	
	public static apiTestSeriesCompTypeList: string = "/api/ols-ws/ws/testSeriesCompTypeList";
	public static apiTestSeriesCompSubTypeList: string = "/api/ols-ws/ws/testSeriesCompSubTypeList";
	public static apiTestSeriesCompSubTypeListTrial: string = "/api/ols-ws/ws/testSeriesCompSubTypeListTrial";
	
	public static apiTestSeriesIndivCompSubMappingList: string = "/api/ols-ws/ws/testSeriesIndivCompSubMappingList";
	public static apiTestSeriesCreateCompSubMappingList: string = "/api/ols-ws/ws/testSeriesCreateIndivCompSubMappingList";
	public static apiTestSeriesUpdateCompSubMappingList: string = "/api/ols-ws/ws/testSeriesUpdateIndivCompSubMappingList";
	public static apiTestSeriesDeleteCompSubMappingList: string = "/api/ols-ws/ws/testSeriesDeleteIndivCompSubMappingList";
	
	public static apiTestSeriesPrepareQuestionSet: string = "/api/ols-ws/ws/testSeriesPrepareQuestionSet";
	public static apiTestSeriesStartTest: string = "/api/ols-ws/ws/testSeriesStartTest";
	public static apiTestSeriesGetIndivTestRecord: string = "/api/ols-ws/ws/testSeriesGetIndivTestRecord";
	public static apiTestSeriesContinuePreviousTest: string = "/api/ols-ws/ws/testSeriesContinuePreviousTest";
	
	public static apiTestSeriesPreviousTestResult: string = "/api/ols-ws/ws/testSeriesPreviousTestResult";
	
}
